import React from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useNavigate } from "react-router-dom";

export default function PgReal() {
  const navigate = useNavigate();

  return (
    <div className="live-video-page">
      <div className="live-wrapper">
        <video
          className="live-video"
          autoPlay
          playsInline
          loop
          src="/images/reels.mp4"
        />

        <div className="live-header">
          <img
            src="images/marija_1.png"
            className="live-avatar"
            alt="profile"
          />
          <div className="live-user-info">
            <span className="live-username">marija_s</span>
          </div>

          <button
            className="leave-live-btn"
            onClick={() => navigate("/notifikacije2")}
          >
            Back
          </button>
        </div>

        <div className="live-chat-box">
          <div className="chat-title">
            Comments <ArrowDropDownIcon />
          </div>

          <div className="chat-messages">
            <div className="chat-message">
              <div className="chat-avatar" />
              <div>
                <div className="chat-name">milos_95</div>
                <div className="chat-text">Vrh!</div>
              </div>
              <span className="chat-time"></span>
            </div>

            <div className="chat-message">
              <div className="chat-avatar" />
              <div>
                <div className="chat-name">milena_85</div>
                <div className="chat-text">Super!</div>
              </div>
              <span className="chat-time"></span>
            </div>
          </div>

          <input
            type="text"
            placeholder="Write comment..."
            className="chat-input-lp"
          />
        </div>
      </div>
    </div>
  );
}
